// Base breadcrumb styles (rendered inline — no inner breadcrumbs-type-1 component delegation)
// Dark-background variant: always uses dark navy background to match hero headers.
sn-breadcrumbs-type-2 {
  .breadcrumbs-type-2 {
    background-color: transparent;

    &__list {
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: calc(var(--spacing-2xs) / 1.25);
    }

    &__item {
      display: flex;
      align-items: center;
      gap: calc(var(--spacing-2xs) * 1.2);

      &:last-child {
        .breadcrumbs-type-2__separator {
          display: none;
        }
      }
    }

    &__link,
    &__text {
      @include text-style('sm', 'md');

      text-decoration: none;
      transition: color 0.2s ease;
    }

    &__link {
      color: var(--color-neutral-white);

      // The 15px/md line box leaves a 21px tap target, under the 24px minimum Lighthouse
      // checks for. Padding rather than a height keeps the crumbs on one line.
      display: inline-flex;
      align-items: center;
      min-height: 24px;

      &:hover {
        color: var(--color-brand-primary-light);
      }
    }

    &__text {
      color: var(--color-neutral-neutral-lighter);
      font-weight: map-get($font-weights, 'normal');
    }

    &__item--current &__text {
      color: var(--color-neutral-neutral-lighter);
      font-weight: map-get($font-weights, 'normal');
      text-decoration: none;
    }

    &__separator {
      display: flex;
      align-items: center;
      margin-top: 3px;

      .me-icon {
        @include size(16px);

        svg {
          fill: var(--color-neutral-white);
        }
      }
    }
  }

  // Was `.me-section` — this block renders its own section now, so the background hooks
  // follow the rename. Still the full-bleed element: the width clamp lives on __container.
  .breadcrumbs-type-2__section {
    width: 100%;
    background-color: rgb(23 30 51 / 70%);
  }

  // Replaces the me-container me-section used to nest inside. y-gap-sm and y-gap-lg-sm
  // both resolve to var(--spacing-sm), so a single padding-block covers both breakpoints.
  .breadcrumbs-type-2__container {
    margin-inline: auto;
    padding-block: var(--spacing-sm);
    padding-inline: var(--spacing-md);
    max-width: var(--me-container-max-width, #{$media-desktop});
  }

  &.breadcrumbs-type-2--transparent {
    .breadcrumbs-type-2__section {
      background-color: transparent;
    }
  }

  // Deep space-blue variant (#000031) — pairs with sn-hero-header-type-7
  &.breadcrumbs-type-2--darkest {
    .breadcrumbs-type-2__section {
      background-color: var(--color-surface-darkest);
    }
  }
}
